import { IconPhone, IconPhoneCall, IconPlugConnected } from '@tabler/icons-react';
import { lazy } from 'react';

import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';

import moduleInfo from '../module.json';

/**
 * Клиентская регистрация модуля телефонии.
 *
 * Журнал звонков идёт первым: это то, ради чего модуль существует, а
 * подключения настраивают однажды.
 */
export async function setup(app: AppRuntime): Promise<void> {
  const telephony = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  const groupTelephony = telephony.createNavigationGroup({
    key: 'telephony',
    label: 'Телефония',
    icon: IconPhone,
    order: 45,
  });

  telephony.useNavigation([
    {
      group: groupTelephony,
      icon: IconPhoneCall,
      label: 'Звонки',
      url: '/telephony/calls',
      component: lazy(() => import('./components/TelephonyCallsList')),
    },
    {
      group: groupTelephony,
      icon: IconPlugConnected,
      label: 'Подключения',
      url: '/telephony/connections',
      component: lazy(() => import('./components/TelephonyConnectionsList')),
    },
  ]);
}
